<template>
  <div>
    <!--banner广告图 start-->
    <el-carousel trigger="click"
                 :height="imgHeight+'px'"
                 style="overflow-y:hidden">
      <el-carousel-item v-for="item in bannerLists"
                        :key="item.id">
        <img :ref="imgHeight" :src="item.src"
             alt
             class="bannerImg">
      </el-carousel-item>
    </el-carousel>
    <!--banner广告图 end-->

    <!--内容 start-->
    <!-- <ul class="homeList">
      <li class="homeMain" v-for="(item,index) in classifyArr" :key="index" v-show="isMasking">
        <div class="homeImg">
          <router-link
            :to="{ path:'/factoring/', query: {customerType:customerType,productId: productId,categoryCode:item.categoryCode} }"
          >
            
            <img :src="`${imgSrcPrefix}${item.categoryImage[0].fileId}`" :alt="item.categoryName">

            <p>{{item.categoryNameBrief}}</p>
          </router-link>
        </div>
        <div class="homeTit">
          <h2>
            <router-link
              :to="{ path:'/products/', query: {customerType:customerType,categoryCode:item.categoryCode}}"
            >{{item.categoryName}}</router-link>
          </h2>
          <p @click="register()">融资利率低至</p>
          <span>{{item.minInterestRate}}%</span>
          <ul>
            <li data-value="1">{{item.categoryDescribe}}</li>
          </ul>
          <router-link
            :to="{ path:'/products/', query: {customerType:customerType,categoryCode:item.categoryCode} }"
            class="btn"
          >立即申请</router-link>
        </div>
      </li>
    </ul>-->
    <ul class="homeList">
      <li class="homeMain"
          v-for="(item,index) in productListData"
          :key="index"
          v-show="isMasking">
        <div class="homeImg"
             @click="detailsRouter(item)">
          <!-- <router-link
            :to="{ path:'/factoring/', query: {customerType:customerType,productId: item.productId,categoryCode:item.proCategoryValue} }"
          >-->

          <img :src="`${imgSrcPrefix}${item.productImg}`"
               :alt="item.categoryName">

          <!-- <p>保理</p> -->
          <!-- </router-link> -->
        </div>
        <div class="homeTit">
          <h2 :class="item.productName.length > 6 ? 'homeTit-title2' : 'homeTit-title'">
            <!-- <router-link
              :to="{ path:'/products/', query: {customerType:this.$route.query.customerType,categoryCode:item.categoryCode}}"
            >{{item.categoryName}}</router-link>-->
            {{item.productName}}
          </h2>
          <div v-if="item.productClassification == 1">
              <p>仅对长期合作客户开放</p>
              <p>折扣利率、资料简化</p>
              <p>融资比例上限提高</p>
          </div>
          <div v-if="item.productClassification == 2">
              <p></p>
              <p></p>
              <p>企业应收转让</p>
              <p>融资速度快</p>
          </div>
          <div v-if="item.productClassification == 3">
              <p></p>
              <p></p>
              <p>买方确权应付</p>
              <p>利率相对优惠</p>
          </div>
          <div v-if="item.productClassification == 4">
              <p></p>
              <p></p>
              <p>仅对战略合作买方体系开放</p>
              <p>解决立账期间短时资金需求</p>
          </div>
          <div v-if="item.productClassification == 5">
              <p></p>
              <p></p>
              <p>提供票据融资咨询服务</p>
              <p>多方合作、渠道无忧</p>
          </div>
          <div v-if="item.productClassification == 6">
            <p></p>
            <p></p>
            <p>融资比例100%</p>
            <p>融资成本较低</p>
          </div>
            
          <!-- <p>年化费率{{item.yearRate ? item.yearRate : 0}}%起</p>
          <p>APP申办最快一天放款</p>
          <p>一个月内不能进行提前结清</p> -->
          <!-- <div class="products-list-item__info">
            <div class="products-list-item__info--content">{{item.productBriefInfo}}</div>
          </div> -->
          <!-- <p class="products-info">{{item.productBriefInfo}}</p> -->
          <!-- <ul>
            <li data-value="1">{{item.categoryDescribe}}</li>
          </ul> -->
          <a @click="detailsRouter(item)"
          :class="item.userName">产品详情</a>
        </div>
      </li>
    </ul>
    <!-- <router-link
      :to="{ path:'/products/', query: {customerType:1,categoryCode:1003} }"
      class="more"
    >查看更多</router-link> -->

    <!--内容 end-->
  </div>
</template>
<script>
// import axios from 'axios';
import api from '../api/index.js';
import apiV from '../vuex/api';
import loanApi from '../api/myloan_bl';
import applyloanApi from '../api/applyloan';
import { mapGetters, mapActions } from 'vuex';
import * as types from '../vuex/types';
import productsApi from '../api/products.js';

export default {
  data () {
    return {
      imgHeight: '', // banner自适应高度
      isMasking: true,
      customerType: '1', // 企业或个人标记
      fileId: 10000069590018,
      classifyArr: [], // 获取的首页列表数据
      productTypeList: '', // 产品分类类别数据
      productListData: '', // 产品分类数据
      productListArr: [], // 产品分类数据
      productListObj: [], // 产品分类数据
      bannerLists: [
        {
          src: require('../assets/images/banner.png'),
          id: '0'
        },
        {
          src: require('../assets/images/banner.png'),
          id: '1'
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      imgSrcPrefix: types.GET_IMAGE_SRC_PREFIX,
      userInfo: types.GET_USER,
      ajaxBaseUrl: types.GET_AJAX_BASE_URL
    })
  },
  created () {
    // this.getProductList();
    this.productsListData();
  },
  // beforeMount () {
  //   this.height = `${$(window).width() * 664 / 1920}px`;
  // },
  methods: {
    ...mapActions({
      setAlertMessage: types.SET_FAIL_MESSAGE
    }),
    // 图片自适应
    setSize () {
      this.$nextTick(function () {
        // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
        this.imgHeight = document.body.clientWidth * 390 / 1920;
      });
    },
    // 获取列表数据
    getProductList () {
      const _this = this;
      api
        .getSetting()
        .then((res) => {
          if (res.rspcode == 1) {
            const data = res.data;

            _this.classifyArr = data;
            if (_this.classifyArr.length == 0) {
              _this.isMasking = false;
            } else {
              _this.isMasking = true;
            }
          } else {
          }
        })
        .catch((err) => {});
    },
    productsListData () {
      const _this = this;
      productsApi
        .getProductListData({
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          isRecommend:1
        })
        .then((res) => {
          if (res.rspcode == 1) {
            const result = [];
            for (let i = 0, len = res.data.proList.length; i < len; i ++) {
              if(res.data.proList[i].productClassification == 1){//池保理
                  res.data.proList[i].userName = 'btn';
              }else if(res.data.proList[i].productClassification == 2){//正向保理
                  res.data.proList[i].userName = 'btn2';
              }else if(res.data.proList[i].productClassification == 3){//反向保理
                  res.data.proList[i].userName = 'btn3';
              }else if(res.data.proList[i].productClassification == 4){//送货融资
                  res.data.proList[i].userName = 'btn4';
              }else if(res.data.proList[i].productClassification == 5){//票据融资
                  res.data.proList[i].userName = 'btn5';
              }else if(res.data.proList[i].productClassification == 6){//供应链融资
                  res.data.proList[i].userName = 'btn6';
              }
            }
            /* for (let i = 0, len = res.data.proList.length; i < len; i += 6) {
              result.push(res.data.proList.slice(i, i + 6));
            }
            for (let j = 0; j < result.length; j++) {
              for (let index = 0; index < result[j].length; index++) {
                if (index === 0) {
                  result[j][index].userName = 'btn';
                }
                if (index === 1) {
                  result[j][index].userName = 'btn2';
                }
                if (index === 2) {
                  result[j][index].userName = 'btn3';
                }
                if (index === 3) {
                  result[j][index].userName = 'btn4';
                }
                if (index === 4) {
                  result[j][index].userName = 'btn5';
                }
                if (index === 5) {
                  result[j][index].userName = 'btn6';
                }
              }
            } */
            const newObject = [];
            for (let k = 0; k < result.length; k++) {
              newObject.push(...result[k]);
            }
            _this.productListData = res.data.proList;
            _this.productListObj = res.data.proList;
            _this.triggerData(res.data.proList);
          }
        })
        .catch((error) => {});
    },
    toApply (item) {
      const _this = this;
      const productId = item.productId;
      const productName = item.productName;
      const productClassification = item.productClassification;
      if (!_.isEmpty(this.userInfo)) {
        apiV.isCurrentUserInBlacklist({// 该接口仅有此处用到，也与state关系不大，暂不考虑放入store，减轻复杂度
          token: this.userInfo.token,
          productId
        }).then((res) => {
          const resData = res.data;
          if (Number(resData.code) === 0) { // 不在黑名单，正常进入流程
            if (productName.includes('供应链')) {
              this.goBlProcess({productId, yanse: 1, productName});
            } else {
              if (productClassification == '1') { // 池保理产品
                loanApi.getPoolItemDetails({ // 详情
                  tokenId: localStorage.getItem('dl_tokenId_bl')
                }).then((res) => {
                  if (res.code == 2) {
                    _this.setAlertMessage({
                      show: true,
                      content: res.msg
                    });
                  } else if (res.code == 0) {
                        // 已申请过池保理
                        /* _this.setAlertMessage({
                          show: true,
                          content: "您已办理过池保理业务，将前往池保理业务界面"
                        });  */
                    this.$router.push({path: `/loanDetail_bl_pool`});
                  } else {
                      // 未申请过池保理
                    this.goBlProcess({productId, yanse: 2, productName});
                  }
                });
              } else {
                this.goBlProcess({productId, yanse: 2, productName});
              }
            }
          } else if (Number(resData.code) === 5) { // 未填写个人或企业信息
            this.setAlertMessage({
              show: true,
              content: resData.result
            });
            this.$router.push('/personalCenter/MyInfo');
          } else if (Number(resData.code) === 3) { // 未实名验证
            this.setAlertMessage({
              show: true,
              content: resData.result
            });
            this.$router.push('/personalCenter/realNameAuth');
          } else if (Number(resData.code) === 2) { // 未添加银行卡
            this.setAlertMessage({
              show: true,
              content: resData.result
            });
            this.$router.push('/personalCenter/bankcardInfo');
          } else if (Number(resData.code) === 9) { // 未额度授信
            this.setAlertMessage({
              show: true,
              content: resData.result
            });
          } else { // 在黑名单，给出提示
            this.setAlertMessage({
              show: true,
              content: resData.result
            });
          }
        }).catch((err) => {
          console.error(err);
          this.$Error(this, err);
        });
      } else {
          // 没有登录
        this.$router.push('/login');
      }
    },
    // 详情跳转
    detailsRouter (item) {
      const productId = item.productId;
      const categoryCode = item.proCategoryValue;
      const productName = item.productName;
      const customerType = this.$route.query.customerType;
      if (categoryCode == '1003') {
        const yanse = productName.includes('供应链') ? 1 : 2;
        this.$router.push({
          path: '/factoring/',
          query: {
            customerType,
            productId,
            productName,
            categoryCode,
            yanse
          }
        });
      } else {
        this.$router.push({
          path: '/product/',
          query: {
            // categoryName: categoryName,
            customerType,
            productId,
            categoryCode
          }
        });
      }
    },
    triggerData (list = []) {
      this.productListArr = [];
      const length = list.length;
      for (let i = 0; i < length; i++) {
        const item = list[i];
        this.productListArr.push(item);
        if (item.proCategoryValue == '1003') {
        }
      }
      const length1 = this.productListArr.length;
      if (length1 >= 8) {
        this.productListData = this.productListArr.slice(0, 8);
        return;
      }
      this.productListData = this.productListArr;
    },
    /**
     * 跳转项目流程
     */
    goBlProcess ({productId, yanse, productName}) {
      applyloanApi.getDraftApply(productId).then((res) => {
        if (Number(res.data.code) === 0) {
          const apply = res.data.result; // 草稿项目
          if (!apply) {
            // 跳转项目流程第一步
            this.$router.push({
              path: `/applyLoan/${productId}/step2_bl`,
              query: {yanse, productName}
            });
          }

          const query = {
            frontApplyId: apply.frontApplyId,
            isEdit: true,
            yanse,
            productName
          };
          switch (apply.applyState) {
            case 'f1':
              // 跳转第二步
              this.$router.push({
                path: `/applyLoan/${productId}/step3_bak_bl`,
                query: {
                  ...query,
                  selectedBankcardId: apply.bankAccountId
                }
              });
              break;
            case 'f2':
              // 跳转第三步
              this.$router.push({
                path: `/applyLoan/${productId}/step3_bl`,
                query: {
                  ...query,
                  selectedBankcardId: apply.bankAccountId
                }
              });
              break;
            case 'f3':
              // 跳转第四步
              this.$router.push({
                path: `/applyLoan/${productId}/step4_bl`,
                query: {
                  ...query,
                  selectedBankcardId: apply.bankAccountId
                }
              });
              break;
            case 'f4':
              // 跳转第五步
              this.$router.push({
                path: `/applyLoan/${productId}/step5_bl`,
                query
              });
              break;
            default:
              // 跳转第一步
              this.$router.push({
                path: `/applyLoan/${productId}/step2_bl`,
                query
              });
              break;
          }
        } else {
          this.setFailMessage({
            show: true,
            content: res.msg || '数据获取失败'
          });
        }
      }).catch((error) => {
        console.error(error);
        this.setFailMessage({
          show: true,
          content: '网络异常，请稍后再试'
        });
      });
    }

  },
  mounted () {
    this.triggerData();
    const _this = this;
    // 浏览器自适应
    this.setSize();
	// 监听窗口变化，使得轮播图高度自适应图片高度
    window.addEventListener('resize', () => {
      this.imgHeight = this.$refs.image[0].height;
    });
  }
};
</script>

<!--统一采用Sass-->

<style lang="scss">
.bannerImg {
  width: 100%;
  min-width: 1400px;
}

.homeList {
  width: 1140px;
  margin: 0 auto;
  padding: 100px 0 10px 0;
  @include clear;
  .homeMain {
    width: 540px;
    height: 270px;
    @include floatLeft;
    margin-bottom: 68px;
    text-align: center;
    box-shadow: 2px 2px 5px #ccc;
    box-sizing: border-box;
    &:hover {
      box-shadow: 2px 2px 10px #444444;
      cursor: pointer;
    }
    &:nth-of-type(odd) {
      margin-right: 60px;
    }
    .homeImg {
      width: 270px;
      height: inherit;
      position: relative;
      float: left;
      img {
        width: 270px;
        height: 270px;
      }
      p {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        line-height: 270px;
        font-size: 75px;
        color: #fff;
      }
    }
    .homeTit {
      width: 270px;
      padding: 27px;
      box-sizing: border-box;
      float: right;
      .homeTit-title {
        font-size: 28px;
    //     overflow: hidden;
    // text-overflow: ellipsis;
    // -ms-text-overflow: ellipsis;
    // white-space:nowrap;
        a {
          color: #00c0ff;
        }
      }
      .homeTit-title2 {
        font-size: 19px;
    //     overflow: hidden;
    // text-overflow: ellipsis;
    // -ms-text-overflow: ellipsis;
    // white-space:nowrap;
        a {
          color: #00c0ff;
        }
      }
      p {
        padding-top: 16px;
        font-size: 16px;
        color: #333;
      }
      span {
        font-size: 32px;
        line-height: 64px;
        color: #00c0ff;
      }
      ul {
        li {
          @include floatLeft;
          font-size: 14px;
          /*margin: 0 auto;*/
          /*border-right: 1px solid #D7D7D7;*/
          padding-left: 20px;
          text-align: center;
          /*&:last-of-type {*/
          /*border: none;*/
          /*}*/
          a {
            color: #666;
          }
        }
      }
      .btn {
        display: block;
        width: 160px;
        line-height: 36px;
        background: #FF653F;
        border-radius: 50px;
        margin-top: 45px;
        font-size: 18px;
        margin-left: 35px;
        color: #fff;
      }
      .btn2 {
        display: block;
        width: 160px;
        line-height: 36px;
        background: #4287EE;
        border-radius: 50px;
        margin-top: 38px;
        font-size: 18px;
        margin-left: 35px;
        color: #fff;
      }
      .btn3 {
        display: block;
        width: 160px;
        line-height: 36px;
        background: #9567EE;
        border-radius: 50px;
        margin-top: 45px;
        font-size: 18px;
        margin-left: 35px;
        color: #fff;
      }
      .btn4 {
        display: block;
        width: 160px;
        line-height: 36px;
        background: #9C745A;
        border-radius: 50px;
        margin-top: 45px;
        font-size: 18px;
        margin-left: 35px;
        color: #fff;
      }
      .btn5 {
        display: block;
        width: 160px;
        line-height: 36px;
        background: #f3b200;
        border-radius: 50px;
        margin-top: 45px;
        font-size: 18px;
        margin-left: 35px;
        color: #fff;
      }
      .btn6 {
        display: block;
        width: 160px;
        line-height: 36px;
        background: #76BC42;
        border-radius: 50px;
        margin-top: 45px;
        font-size: 18px;
        margin-left: 35px;
        color: #fff;
      }
    }
  }
}
// .more {
//   display: block;
//   margin-left:190px;
//   margin-bottom: 50px;
//   color: #00c0ff;
//   font-size: 18px;
// }
</style>



// WEBPACK FOOTER //
// Index.vue?c1781bee